import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { Observable, catchError, throwError, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  private baseUrl = environment.apiUrl;
  private eskaUrl = 'https://eskabatch.services.heirslifeassurance.com/api/v1/';
  public loader = false;
  public smLoader = false;
  constructor(
    private http: HttpClient,
    private r: Router,
    private tstr: ToastrService
  ) {}
  private httpClientHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')!}`,
      }),
    };
  }
  getWalletBal() {
    return this.http
      .get(this.baseUrl + 'api/get/wallet', this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  getCompanyDetails() {
    return this.http
      .get(this.baseUrl + 'api/get/company/details', this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }

  getSingleMemberPolicyDetails(data: {}) {
    this.loader = true;
    return this.http
      .post(this.baseUrl + 'api/create/company', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  getPolicyDetails(id: string) {
    this.loader = true;
    return this.http
      .get(this.baseUrl + 'api/customers/' + id, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  getDestination(id: string) {
    return this.http
      .get(this.baseUrl + 'api/getCountry/' + id, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  deletee(id: string) {
    this.loader = true;
    return this.http
      .delete(this.baseUrl + 'api/removeUser/' + id, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  getPkgs() {
    this.smLoader = true;
    return this.http
      .get(this.baseUrl + 'api/getAllCategories', this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  errHdlr = (err: any, caught: Observable<any>): any => {
    this.loader = false;
    this.smLoader = false;
    console.log(err);
    if (err.status == 401) {
      // err.error
      this.tstr.error('Session Expired');
      localStorage.clear()
      this.r.navigateByUrl('signin');
    } 
    // else {
    //   if(err){
    //     this.tstr.error("An Error occured")
    //   }
    //   this.tstr.error('' + JSON.stringify(err.error));
      
    //   if(err.message && err.message.toString().includes('Http failure response for')){
    //     this.tstr.error('Check Your Internet Connection')
    //   }

    // }
  };
  
  getCountries(id?: string) {
    this.smLoader = true;
    if (id == undefined) {
      return this.http
        .get(this.baseUrl + 'api/getAllCountries', this.httpClientHeaders())
        .pipe(catchError(this.errHdlr));
    } else {
      return this.http
        .get(
          this.baseUrl + 'api/getCountriesWithPackageId/' + id,
          this.httpClientHeaders()
        )
        .pipe(catchError(this.errHdlr));
    }

    //  }catch(e){
    //   this.loader = false;
    //   console.log("erorr",e)

    //  }
    // .pipe(
    //   catchError((err: any, caught: Observable<any>): Observable<[]> => {
    //    this.loader = false;
    //     console.log('error is ', err);
    //     return of([]) ;
    //   })
    // );
  }
  placeTrxn(data: {}) {
    this.loader = true;
    return this.http
      .post(this.baseUrl + 'api/create/company', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  makePyt(data: {}) {
    this.loader = true;
    return this.http
      .post(
        this.baseUrl + 'api/place/transaction',
        data,
        this.httpClientHeaders()
      )
      .pipe(catchError(this.errHdlr));
  }
  confirmPayment(data: string, gateway:string) {
    this.loader = true;
    return this.http
      .get(
        this.baseUrl + 'api/transaction/paystack-callback?reference=' + data + '&gateway='+gateway,
        this.httpClientHeaders()
      )
      .pipe(catchError(this.errHdlr));
  }
  getAllTrxns() {
    this.loader = true;
    return this.http
      .get(
        this.baseUrl + 'api/all/transaction/company',
        this.httpClientHeaders()
      )
      .pipe(catchError(this.errHdlr));
  }
  getAllTrxnsByCmpny(email: string) {
    this.loader = true;
    return this.http
      .get(
        this.baseUrl + 'api/allProceBycompanyEmail?companyEmail=' + email,
        this.httpClientHeaders()
      )
      .pipe(catchError(this.errHdlr));
  }

  getCommission() {
    this.loader = true;
    return this.http
      .get(this.baseUrl + 'api/get/commission', this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  hg() {
    this.loader = false;
  }

  // handleError(error: HttpErrorResponse) {
  //   // this.hg()
  //   if (error.status === 0) {
  //     // A client-side or network error occurred. Handle it accordingly.
  //     console.error('An error occurred:', error.error);
  //     this.tstr.error(error.error);
  //   } else {
  //     // The backend returned an unsuccessful response code.
  //     // The response body may contain clues as to what went wrong.
  //     console.error(
  //       `Backend returned code ${error.status}, body was: `,
  //       error.error
  //     );
  //   }
  //   // Return an observable with a user-facing error message.
  //   this.tstr.error(error.error);
  //   return throwError(
  //     () => new Error('Something bad happened; please try again later.')
  //   );
  // }
  // sendSingle(data: FormData) {
  //   this.loader = true;
  //   let header = {
  //     headers: new HttpHeaders({
  //       Authorization: `Bearer ${localStorage.getItem('token')!}`,
  //     }),
  //   };
  //   return this.http
  //     .post(this.baseUrl + 'api/buyTravel', data, header)
  //     .pipe(catchError(this.errHdlr));
  // }

  sendSingle(data: {}) {
    this.loader = true;
    return this.http
      .post(this.baseUrl + 'api/buyTravel', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }

  fundWallet(data: {}) {
    console.log(data)
    this.loader = true;
    return this.http
      .post(this.baseUrl + 'api/fund-wallet', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }

  verifyPayment(ref: string, gateway:string) {
    this.loader = true;
    return this.http
      .get(
        this.baseUrl + 'api/paystack-callback?reference=' + ref + '&gateway='+gateway,
        this.httpClientHeaders()
      )
      .pipe(catchError(this.errHdlr));
  }
  submitQuery(file: any, data :{}) {
    this.loader = true;
    let y = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('token')!}`,
      }),
    };
    if (file) {
      console.log(data)
       this.http
        .post(this.baseUrl + 'api/update/company', data, y)
        .pipe(catchError(this.errHdlr)).subscribe(r=>{
          console.log(r)
        })
        return this.http
        .post(this.baseUrl + 'api/upload/cac/only', file, y)
        .pipe(catchError(this.errHdlr));

    } else {
      return this.http
        .post(this.baseUrl + 'api/update/company', data, y)
        .pipe(catchError(this.errHdlr));
    }
  }

  requestEdit(data: {}){
    this.loader = true;

    return this.http
      .post(this.baseUrl + 'api/complaint/request/form', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }

  getQoute(data:{}){
    this.loader = true;
    return this.http
      .post(
        this.baseUrl + 'api/get-quotation', data,
        this.httpClientHeaders()
      )
      .pipe(catchError(this.errHdlr));
  }
  retrigerCertificate(data:{}){
    this.loader = true;
    return this.http
      .post(this.baseUrl + 'api/certificate/retrigger', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }

  disableOpenCover(data:{}){
    this.loader = true;
    return this.http
      .post(this.baseUrl + 'api/switchUnitFn', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }

  isReconciled(data:{}){
    this.loader = true;
    return this.http
      .post(this.baseUrl + 'api/transaction/reconcile', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }

  uploadPaymentEvidence(data: FormData) {
    this.loader = true;
    let header = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('token')!}`,
      }),
    };
    return this.http.post(this.baseUrl + 'api/upload/paymentEvidence', data, header)
    .pipe(catchError(this.errHdlr));
  }

  createClaim(data: FormData) {
    this.loader = true;
    let header = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('token')!}`,
      }),
    };
    return this.http.post(this.baseUrl + 'api/create/claim', data, header)
    .pipe(catchError(this.errHdlr));
  }

  getAClaim(email: any) {
    this.loader = true;
    return this.http.post(this.baseUrl + 'api/get/aClaim',email, this.httpClientHeaders())
    .pipe(catchError(this.errHdlr));
  }

  uploadPassport(data: FormData) {
    this.loader = true;
    return this.http.post(this.eskaUrl + 'general/uploadImg', data)
    .pipe(catchError(this.errHdlr));
  }
}